import VideoRecommendationsGrid                   from './VideoRecommendationsGrid';
import PropTypes                                  from 'prop-types';
import React                                      from 'react';
import Flux                                       from '../../flux/Flux';
import withVideoRecommendationsByActorIdOrAlbumId from "../HigherOrderComponents/ActorProfileVideos/withVideoRecommendationsByActorIdOrAlbumId";

const VideoRecommendationsGridByActor = props => (
	<VideoRecommendationsGrid id={props.actorId}
	                          sameActor={props.sameActor}
	                          fetchData={props.fetchData}
	                          getVideoRecommendationsById={(id, sameActor) =>
		                          Flux.Actor.getVideoRecommendationsByActorId(id, sameActor)}
	                          loadVideoRecommendationsById={(id, sameActor, count) =>
		                          Flux.Actor.loadVideoRecommendationsByActorId(id, sameActor ? count : 0, !sameActor ? count : 0)
	                          }
	                          addVideoRecommendationsChangeListener={id => Flux.Actor.addVideoRecommendationsByActorIdChangeListener(id)}
	                          removeVideoRecommendationsChangeListener={id => Flux.Actor.removeVideoRecommendationsByActorIdChangeListener(id)}
	                          actorId={props.actorId}
	                          actorName={props.actorName}
	                          displayTooFewItemsTile={props.displayTooFewItemsTile}
	                          displayCount={props.isSidebarEnabled ? null : props.displayCount}
	                          slider={props.slider}
	                          videos={props.videos}
							  lazyImageLoading={props.lazyImageLoading}
                              isSidebarEnabled={props.isSidebarEnabled}
	/>
);

VideoRecommendationsGridByActor.propTypes = {
	sameActor:              PropTypes.bool.isRequired,
	fetchData:              PropTypes.bool,
	actorId:                PropTypes.number.isRequired,
	actorName:              PropTypes.string.isRequired,
	displayTooFewItemsTile: PropTypes.bool,
	displayCount:           PropTypes.number,
	slider:                 PropTypes.bool,
	videos:                 PropTypes.array,
	lazyImageLoading:       PropTypes.bool,
	isSidebarEnabled:       PropTypes.bool,
};

VideoRecommendationsGridByActor.defaultProps = {
	fetchData:              true,
	displayTooFewItemsTile: true,
	lazyImageLoading:       false,
	isSidebarEnabled:       false,
};

export default withVideoRecommendationsByActorIdOrAlbumId(VideoRecommendationsGridByActor, true);
